const img = require('./Product.svg'); export default img;